import { FC } from 'react';
import { pdf } from '@react-pdf/renderer';
import DailyReportPDF from '../../../components/UI/PdfReport/DailyReportPDF';
import { IPDFReportData } from '../../../models/pdfReport';
import { useExcelExport } from '../../../hooks/useExcelExport';
import { TextButton } from '../Button/Text';
import { format } from 'date-fns';
import pdfIcon from '../../../assets/icons/icon-pdf.png';
import excelIcon from '../../../assets/icons/icon-excel.svg';

interface IProps {
    date: string;
    data: IPDFReportData;
    dataLoaded: boolean;
}

const DownloadLink: FC<IProps> = ({ date, data, dataLoaded }) => {
    const { exportToExcel } = useExcelExport(data);

    if (!dataLoaded) return null;

    const handleDownloadAll = async () => {
        for (const project of data.projects) {
            const filename = `${project.name} - Report of ${format(new Date(date), 'MMMM do, yyyy')}.pdf`;

            const blob = await pdf(<DailyReportPDF data={{ ...data, projects: [project] }} />).toBlob();

            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'row', gap: '10px', alignItems: 'flex-start', marginLeft: '20px' }}>
            <TextButton label="Download PDF Reports" icon={pdfIcon} onClick={handleDownloadAll} />
            <TextButton label="Download Excel Reports" icon={excelIcon} onClick={exportToExcel} />
        </div>
    );
};

export default DownloadLink;
